import { render, staticRenderFns } from "./SocialAuthCallback.vue?vue&type=template&id=5f69f67a"
import script from "./SocialAuthCallback.vue?vue&type=script&lang=js"
export * from "./SocialAuthCallback.vue?vue&type=script&lang=js"
import style0 from "./SocialAuthCallback.vue?vue&type=style&index=0&id=5f69f67a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports